export default function( node ) {
	if ( ! node ) {
		return;
	}

	const prev = node.previousElementSibling;
	const next = node.nextElementSibling;

	if ( ! prev || ! next ) {
		return;
	}

	if ( prev.classList.length ) {
		for ( let i = 0; i < prev.classList.length; i++) {
			if ( prev.classList[i].match( /has-[a-zA-z]+-background-color/ ) ) {
				node.classList.add( `prev-${prev.classList[i]}`);
				break;
			}
		}
	}

	if ( next.classList.length ) {
		for ( let i = 0; i < next.classList.length; i++) {
			if ( next.classList[i].match( /has-[a-zA-z]+-background-color/ ) ) {
				node.classList.add( `next-${next.classList[i]}`);
				break;
			}
		}
	}
}
